export const initialState = {
  keyword: '',
  creatorTypeId: null as string | null,
  isBlocked: null as boolean | null,
  ekycStatus: null as string | null,
  pageIndex: 1,
  pageSize: 10,
  totalPage: 0,
  totalRecords: 0,
  customerList: [],
  selectedCustomer: {},
  userPoints: [],
  isOpenAddPointDialog: false,
  reports: [],
  creatorTypes: [],
  isOpenModalCreatorType: false,
  creatorTypeEdit: {},
  creatorTypeEditDetail: {},
  isOpenModalCreatorTypeEdit: false,
  creatorTypeDeleteId: null as string | null,
  isOpenModalCreatorTypeDelete: false,
  creatorTypeHistoryList: [],
  creatorTypeHistoryPageIndex: 1,
  creatorTypeHistoryPageSize: 10,
  creatorTypeHistoryTotalPage: 0,
  creatorTypeHistoryTotalRecords: 0,
  modelOpened: null as string | null,
  isUploading: false,
  isDownloading: false,
  orderDirection: '',
  orderField: ''
}
